exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vehicle-tracking-settings-external{padding-top:10px}\n", ""]);

// exports
